module.exports = __webpack_public_path__ + "static/media/camera.c2fdf4a0.jpg";